export default __webpack_public_path__ + "static/media/PROJECT 3.0f2b8e0a.png";